export const PUBLIC_VIEW_STYLES_URL =
  "https://superplayerauction.com/new2025/styles.css";

export const FONT_AWESOME_URL =
  "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css";

// CSS variable → React state setter key
export const CSS_VAR_TO_STATE = {
  "--ttl-clr": "color",
  "--plr-nmclr": "color2",
  // "--tm-nm-txtclr": "color5",
  "--plr-cd-txtclr": "color3",
  "--plr-cd-bgclr1": "color4",
  "--plr-cd-bgclr2": "color5",
  "--crnt-bdclr": "color6",

  // "--ttl-ptclr": "color2",
  // "--df-txtclr": "color3",
  // "--plr-dtl-txtclr": "color3",
  // "--crnt-bdclr": "color2",
  // "--mx-bdclr": "color4",
  // add more as you wire more pickers
};

// React state → CSS variable (for themeVars prop)
export const STATE_TO_CSS_VAR = {
  color: "--ttl-clr",
  color2: "--plr-nmclr",
  color5: "--tm-nm-txtclr",
  color3: "--plr-cd-txtclr",
  color4: "--plr-cd-bgclr1",
  color5: "--plr-cd-bgclr2",
  color6: "--crnt-bdclr",

  // color4: "--mx-bdclr",
  // color2: "--ttl-ptclr",
};

export function parseCssColorVars(cssText) {
  const block = cssText.match(/:host\s*,\s*:root\s*\{([^}]+)\}/);
  if (!block) return {};

  const vars = {};
  for (const [, name, value] of block[1].matchAll(
    /--([\w-]+)\s*:\s*([^;]+)/g,
  )) {
    const v = value.trim();
    if (!v.startsWith("url(")) vars[`--${name}`] = v;
  }
  return vars;
}

export function buildThemeVarsFromState(state) {
  const themeVars = {};
  Object.entries(STATE_TO_CSS_VAR).forEach(([stateKey, cssVar]) => {
    const val = state[stateKey];
    if (val) themeVars[cssVar] = val;
  });
  return themeVars;
}

/** Convert computed CSS color (hex, rgb, rgba) for color inputs */
export function cssVarValueToHex(value) {
  if (!value) return "";
  const v = value.trim();
  if (v.startsWith("#")) {
    return v.length === 4
      ? `#${v[1]}${v[1]}${v[2]}${v[2]}${v[3]}${v[3]}`
      : v.slice(0, 7);
  }

  const rgb = v.match(
    /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*[\d.]+)?\s*\)/,
  );
  if (rgb) {
    const hex = (n) => Number(n).toString(16).padStart(2, "0");
    return `#${hex(rgb[1])}${hex(rgb[2])}${hex(rgb[3])}`;
  }

  return v;
}

/** Read mapped CSS variables from the shadow host element */
export function readHostCssVars(host) {
  if (!host) return {};

  const computed = getComputedStyle(host);
  const vars = {};

  Object.keys(CSS_VAR_TO_STATE).forEach((cssVar) => {
    const raw = computed.getPropertyValue(cssVar).trim();
    if (raw) vars[cssVar] = cssVarValueToHex(raw);
  });

  return vars;
}

/** Map CSS variable values to React color state keys */
export function cssVarsToStateUpdates(cssVars) {
  const updates = {};

  Object.entries(cssVars).forEach(([cssVar, value]) => {
    const stateKey = CSS_VAR_TO_STATE[cssVar];
    if (stateKey && value) updates[stateKey] = value;
  });

  return updates;
}

// Optional: normalize for <input type="color">
export function toHexColor(value) {
  if (!value) return "#ffffff";
  if (value.startsWith("#")) return value;
  return value; // add rgb→hex later if needed
}